import React from 'react';
import Logo from "../../../1.resources/3.files/logo/logo_white.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Links from '../header/links';

const Footer = () => {

    return (
        <div className='flex justify-center items-center pb-8 pt-4'>
            <div className='w-full lg:w-[1280px] mx-10 md:px-0' style={{ zIndex: 1000000 }}>

                <div className='md:flex justify-between items-center md:items-start'>
                    <div className='flex md:block flex-col items-center md:items-start'>
                        <a href="/" className="flex items-center gap-x-2">
                            <p className="text-2xl text-white ">WEWE</p>
                        </a>
                        <p className='text-white text-[12px] mt-2'>© W3 Labs, 2021</p>

                    </div>

                    <div className='text-center md:text-right mt-8 md:mt-0'>
                        <Links />
                        <p className='text-white mt-2' >Email: contact@w3.one</p>

                    </div>
                </div>
                <div className='text-center pt-4'>

                </div>
            </div>

        </div>
    )
}

export default Footer;
